/**
 * 2018 - Triad Berlin Projektgesellschaft mbH
 * 
 * @author Jan Bundschuh
 */
export default class Combinator {

    /**
     * Der Konstruktor.
     * 
     * @param {*} keys Der mögliche Input zur überprüfung.
     * @param {*} combination Die Kombination die vom Kombinator geprüft wird.
     * @param {*} audios Die Elemente für das Audio-Feedback.  
     */
    constructor(keys, combination, audios) {

        this.currentCombination = combination;
        this.possibleKeys = keys;

        console.log(this.currentCombination)
        // FUCK IE
        if (!Array.prototype.includes) {
            Object.defineProperty(Array.prototype, "includes", {
                enumerable: false,
                value: function(obj) {
                    var newArr = this.filter(function(el) {
                    return el == obj;
                    });
                    return newArr.length > 0;
                }
            });
        }

        this.audios = audios;
        this.currentInput = [];
        this.successCounter = 0;
        this.failCounter = 0;
        this.successCallback = null;
        this.succcessStepCallback = null;
        this.failCallback = null;
        this.active = false;
    }

    /**
     * Fürs bearbeiten der Tasteneingaben.
     * 
     * @param {*} currentKey  Der Key-Code der Taste die gedrück wurde. 
     */
    keyDown(currentKey) {
        if (!this.active) return;
        currentKey = currentKey.toUpperCase();
        if (!this.possibleKeys[currentKey]) {
            console.log('not in range');
            return; 
        } 

        let index = this.possibleKeys[currentKey];
        let audio = this.audios[index - 1];

        if (audio) {
            audio.pause();
            audio.currentTime = 0;
            audio.volume = window.volume;
            var playPromise = audio.play();
            if (playPromise !== undefined) {
                playPromise.then(_ => {}).catch(error => {});
            }
        }

        this.currentInput.push(index);
        var last = this.currentInput[this.currentInput.length - 1];

        if (last != this.currentCombination[this.currentInput.length - 1]) {
            this.failCounter++;
            this.currentInput = [];
            if (this.failCallback != null) {
                this.failCallback();
            }
        }  else {
            if (this.succcessStepCallback != null) {
                this.succcessStepCallback(this.currentInput.length - 1, this.currentCombination);
            }

            if (this.currentInput.length == this.currentCombination.length) {
                this.successCounter++;
                this.currentInput = [];
                if (this.successCallback != null) {
                    this.successCallback();
                }
            }
        }
    }

    /**
     * Setzt alle Counter und Inputs zurück.
     */
    reset() {
        this.currentInput = [];
        this.successCounter = 0;
        this.failCounter = 0;
    }
}
    


// WEBPACK FOOTER //
// ./src/components/Combinator.js